(function() {
  let currentUnit = "imperial";

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function getAll(id) {
    return Array.prototype.slice.call(document.querySelectorAll("#" + id));
  }

  function lastById(id) {
    const items = getAll(id);
    return items.length ? items[items.length - 1] : null;
  }

  function cleanupDuplicateModals() {
    const modals = getAll("sizechart-modal");
    if (modals.length <= 1) return;

    const keep = modals[modals.length - 1];

    modals.forEach(function(modal) {
      if (modal !== keep) {
        modal.remove();
      }
    });
  }

  function getDataSet() {
    return window.__SIZECHARTS__ || {};
  }

  function getTags(bridge) {
    const raw =
      bridge.getAttribute("data-sizechart-tags") ||
      bridge.getAttribute("data-sizechart-tag") ||
      "";

    return String(raw)
      .split(",")
      .map(normalize)
      .filter(Boolean);
  }

  function findChartKey(bridge) {
    const dataSet = getDataSet();
    const tags = getTags(bridge);

    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i];

      if (
        tag.indexOf("sizechart-") === 0 &&
        Object.prototype.hasOwnProperty.call(dataSet, tag)
      ) {
        return tag;
      }
    }

    return null;
  }

  function moveModalToBody() {
    cleanupDuplicateModals();

    const modal = lastById("sizechart-modal");

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function extractHtmlTable(htmlString) {
    const temp = document.createElement("div");
    temp.innerHTML = htmlString;

    const table = temp.querySelector("table");
    return table ? table.outerHTML : htmlString;
  }

  function buildTableFromObject(data) {
    const columns = data.columns || data.headers || [];
    const rows = data.rows || [];

    if (!columns.length || !rows.length) return "";

    let html = "";
    html += '<div class="table-responsive" style="width:100%; overflow-x:auto;">';
    html += "<table><thead><tr>";

    columns.forEach(function(col) {
      html += "<th>" + col + "</th>";
    });

    html += "</tr></thead><tbody>";

    rows.forEach(function(row) {
      html += "<tr>";

      columns.forEach(function(col, index) {
        let value = "";

        if (Array.isArray(row)) {
          value = row[index] || "";
        } else if (row && typeof row === "object") {
          value = row[col] || "";
        }

        html += "<td>" + value + "</td>";
      });

      html += "</tr>";
    });

    html += "</tbody></table></div>";

    return html;
  }

  function getCurrentChart() {
    const bridge = lastById("sizechart-content");
    const dataSet = getDataSet();

    if (!bridge) return null;

    const key = findChartKey(bridge);
    if (!key || !dataSet[key]) return null;

    return dataSet[key];
  }

  function getCurrentData(chart) {
    if (!chart) return null;

    if (typeof chart === "string") return chart;

    if (chart[currentUnit]) return chart[currentUnit];

    if (chart.imperial) {
      currentUnit = "imperial";
      return chart.imperial;
    }

    if (chart.metric) {
      currentUnit = "metric";
      return chart.metric;
    }

    return chart;
  }

  function drawSizeChart() {
    cleanupDuplicateModals();

    const injected = lastById("sizechart-injected");
    const chart = getCurrentChart();

    if (!injected || !chart) return false;

    const data = getCurrentData(chart);

    if (!data) {
      injected.innerHTML = "";
      return false;
    }

    let html = "";

    if (typeof data === "string") {
      html = extractHtmlTable(data);
      html = '<div class="table-responsive" style="width:100%; overflow-x:auto;">' + html + "</div>";
    } else if (typeof data === "object") {
      html = buildTableFromObject(data);
    }

    if (!html) {
      injected.innerHTML = "";
      return false;
    }

    html += '<p class="sizechart-note">Measurements are in <strong>';
    html += currentUnit === "imperial" ? "inches" : "centimeters";
    html += "</strong>.</p>";

    injected.innerHTML = html;
    return true;
  }

  function initSizeChart() {
    cleanupDuplicateModals();

    const bridge = lastById("sizechart-content");
    const btn = lastById("open-sizechart");

    if (!bridge || !btn) return;

    moveModalToBody();

    bridge.style.setProperty("display", "none", "important");
    btn.style.setProperty("display", "none", "important");

    const key = findChartKey(bridge);

    if (!key) return;

    bridge.style.setProperty("display", "inline-block", "important");
    btn.style.setProperty("display", "inline-flex", "important");

    document.querySelectorAll(".unit-btn").forEach(function(button) {
      button.classList.toggle(
        "active",
        button.getAttribute("data-unit") === currentUnit
      );
    });
  }

  function openModal(e) {
    e.preventDefault();

    initSizeChart();

    const modal = lastById("sizechart-modal");
    if (!modal) return;

    const ok = drawSizeChart();
    if (!ok) return;

    modal.style.display = "flex";
    document.body.style.overflow = "hidden";

    setTimeout(function() {
      modal.classList.add("active");
    }, 10);
  }

  function closeModal() {
    const modal = lastById("sizechart-modal");
    if (!modal) return;

    modal.classList.remove("active");
    document.body.style.overflow = "";

    setTimeout(function() {
      modal.style.display = "none";
    }, 250);
  }

  document.addEventListener("click", function(e) {
    const sizeBtn = e.target.closest("#open-sizechart");

    if (sizeBtn) {
      openModal(e);
      return;
    }

    const unitBtn = e.target.closest(".unit-btn");

    if (unitBtn) {
      e.preventDefault();

      currentUnit = unitBtn.getAttribute("data-unit") || "imperial";

      document.querySelectorAll(".unit-btn").forEach(function(button) {
        button.classList.remove("active");
      });

      unitBtn.classList.add("active");
      drawSizeChart();
      return;
    }

    if (e.target.closest("#close-sizechart-x") || e.target.id === "sizechart-modal") {
      closeModal();
    }
  });

  function delayedInit() {
    setTimeout(initSizeChart, 50);
    setTimeout(initSizeChart, 250);
    setTimeout(initSizeChart, 700);
  }

  window.initSizeChart = initSizeChart;
  window.__drawSizeChart = drawSizeChart;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", delayedInit);
  } else {
    delayedInit();
  }

  window.addEventListener("load", delayedInit);
  document.addEventListener("variant:change", delayedInit);
  document.addEventListener("shopify:section:load", delayedInit);
  document.addEventListener("shopify:section:select", delayedInit);

  const observer = new MutationObserver(function() {
    delayedInit();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();